<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="添加单位"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="625px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
			<el-form-item label="单位名称：" prop="unitName">
			  <el-input
			    size="mini"
			    v-model.trim="form.unitName"
			    placeholder="请输入单位名称"
			    clearable
			  ></el-input>
			</el-form-item>
				<el-form-item label="社会信用代码：" class="mr0 label-with-six-word" label-width="98px">
				  <el-input
				    size="mini"
				    v-model.trim="form.creditCode"
				    placeholder="请输入社会信用代码"
				    clearable
				  ></el-input>
				</el-form-item>
        <el-form-item label="联系人：">
          <el-input
            size="mini"
            v-model.trim="form.contactsName"
            placeholder="请输入联系人"
            clearable
          ></el-input>
        </el-form-item>
				<el-form-item label="联系电话：" class="mr0">
				  <el-input
				    size="mini"
				    v-model.trim="form.contactsPhone"
				    placeholder="请输入联系电话"
				    clearable
				  ></el-input>
				</el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" type="primary" size="mini" :loading="loadBtn" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { addUnit } from '@/api/UnitManagement'
export default {
  data() {
    return {
      form: {
        contactsPhone: '',
        contactsName: '',
        creditCode: '',
        unitName: ''
      },
      rules: {
        unitName: [
          {
            required: true,
            message: '请输入单位名称',
            trigger: 'blur'
          }
				]
      },
      loadBtn: false
    }
  },
  created() {
  },
  methods: {
    handleBeforeClose(done) {
      this.$emit('cancel')
      done()
    },
    handleCancel() {
      this.$emit('cancel')
    },
    async handleConfirm() {
      if (this.loadBtn) return
      this.$refs['form'].validate(async valid => {
        if (valid) {
          this.loadBtn = true
          const res = await addUnit(this.form)
          if (res.code === 200) {
            this.$message.success('添加成功')
            this.$emit('confirm')
          }
          this.loadBtn = false
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/MaintenanceDetail/components/AddUnit.vue